import { truncateMiddle } from 'src/presentations/elements/Text'
import { findOne } from 'src/utils/graph/GraphExplorer'
import { translate } from "src/utils/translate";

/**
 * Gestion du breadcrumb
 * @param  {any}    emitter [description]
 * @return {[type]}         [description]
 */
export default function Listener(emitter: any): any {
  emitter.on({
    event: 'breadcrumb',
    route: `/:language/companies/:companyId`,
    resolver: async ({ routeParams }: any) => {
      return [{ text: translate(routeParams.language,'Home'), link: `/${routeParams.language}`, active: true }]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: `/:language/companies/:companyId/banks`,
    resolver: async ({ routeParams }: any) => {
      return [{ text: translate(routeParams.language,'Home'), link: `/${routeParams.language}`, active: true }]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/pre-trained',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'AI Marketplace') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/publicInference/:publicInfID',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/` },
        { active: true, text: translate(routeParams.language,'public-Inference') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/data-stores',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
        { active: true, text: translate(routeParams.language,'Data stores') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
        { active: true, text: translate(routeParams.language,'Projects') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
        { active: true, text: translate(routeParams.language,'Datasets') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/inferences/:id',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Inference',
          alias: 'row',
          where: { id: routeParams.id },
          output: {
            id: true,
            name: true
          },
        });

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Inferencia'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences` },
          { text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences/${truncateMiddle(result.row.name, 20, "...")}`, active: true },
        ];
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Inferencia'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences` },
          { text: translate(routeParams.language,'Inferences model'), active: true },
        ];
      }
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/pre-trained/:id',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'AI Marketplace'), active: true },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/pre-trained/:category/:id',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Inference',
          alias: 'row',
          where: { id: routeParams.id },
          output: {
            id: true,
            name: true,
            category: true
          },
        });
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'AI Marketplace'), link: `/${routeParams.language}/companies/${routeParams.companyId}/pre-trained/All` },
          { text: translate(routeParams.language,`${result.row.category}`), link: `/${routeParams.language}/companies/${routeParams.companyId}/pre-trained/${result.row.category}` },
          { text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/pre-trained/${truncateMiddle(result.row.name, 20, "...")}`, active: true },
        ];
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'AI Marketplace'), link: `/${routeParams.language}/companies/${routeParams.companyId}/pre-trained` },
          { text: translate(routeParams.language,'Pre-trained model'), active: true },
        ];
      }
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/heatmaps',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'dataset',
          alias: 'row',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          {
            text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets/${routeParams.datasetID}/information`,
          },
          { text: translate(routeParams.language,'heatmaps'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: translate(routeParams.language,'heatmaps'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/analytics/:requestID/document',
      '/:language/companies/:companyId/analytics/:requestID/Information',
      '/:language/companies/:companyId/analytics/:requestID/analyticsInfo',
      '/:language/companies/:companyId/analytics/:requestID/response-api'
    ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'request',
          alias: 'row',
          where: { id: routeParams.requestID },
          output: {
            id: true,
            number: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Analytics'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics` },
          {
            text: `#${result.row.number}`, active: true
          }
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Analytics'), link: `/${routeParams.language}/companies/${routeParams.companyId}/analytics` },
          { text: translate(routeParams.language,'Request item'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/analytics',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'dataset',
          alias: 'row',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          {
            text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets/${routeParams.datasetID}/information`,
          },
          { text: translate(routeParams.language,'analytics'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: translate(routeParams.language,'Analytics'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/preview',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'dataset',
          alias: 'row',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          {
            text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets/${routeParams.datasetID}/information`,
          },
          { text: translate(routeParams.language,'Preview'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: translate(routeParams.language,'Preview'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/logs',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'dataset',
          alias: 'row',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets/${routeParams.datasetID}/information`, },
          { text: translate(routeParams.language,'Logs'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: translate(routeParams.language,'Logs'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/settings',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'dataset',
          alias: 'row',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: truncateMiddle(result.row.name, 20, "..."), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets/${routeParams.datasetID}/information`, },
          { text: translate(routeParams.language,'Settings'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: translate(routeParams.language,'Settings'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/information',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'dataset',
          alias: 'row',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: truncateMiddle(result.row.name, 20, "..."), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: translate(routeParams.language,'Information'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/:datasetID/information',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'datasets',
          alias: 'rows',
          where: { id: routeParams.datasetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
          { text: truncateMiddle(result.rows.name, 20, '...'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Dataset'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/data-stores/:presetID/editor',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Preset',
          alias: 'rows',
          where: { id: routeParams.presetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Data stores'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
          { text: truncateMiddle(result.rows.name, 20, '...'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Data stores'), active: true },
        ]
      }
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/data-stores/:presetID/settings',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Preset',
          alias: 'rows',
          where: { id: routeParams.presetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Data stores'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
          { text: truncateMiddle(result.rows.name, 20, '...'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Dataset'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/data-stores/:presetID/logs',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Preset',
          alias: 'rows',
          where: { id: routeParams.presetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Data stores'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
          { text: truncateMiddle(result.rows.name, 20, '...'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Dataset'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/data-stores/:presetID/archive',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Preset',
          alias: 'rows',
          where: { id: routeParams.presetID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Data stores'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
          { text: truncateMiddle(result.rows.name, 20, '...'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Dataset'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/add-project',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
        { active: true, text: translate(routeParams.language,'New Project') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/data-stores/add-preset',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Data stores'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
        { active: true, text: translate(routeParams.language,'New Data store') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/add-dataset',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
        { active: true, text: translate(routeParams.language,'New Dataset') },
      ]
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/datasets/upload-dataset',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Datasets'), link: `/${routeParams.language}/companies/${routeParams.companyId}/datasets` },
        { active: true, text: translate(routeParams.language,'Upload Dataset') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/add-scene',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'projects',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${routeParams.projectID}/scenes`,
          },
          { active: true, text: translate(routeParams.language,'New scene') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { active: true, text: translate(routeParams.language,'New scene') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/settings',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/overview`,
          },
          { text: translate(routeParams.language,'Settings'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Settings'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/labelling',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/overview`,
          },
          { text: translate(routeParams.language,'Labelling'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Labelling'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/scenes',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/overview`,
          },
          { text: translate(routeParams.language,'Scenes'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Scenes'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/overview',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), active: true, link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/overview`,
          }
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Overview'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/new-scene',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/overview`,
          },
          { text: translate(routeParams.language,'New scene'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'New scene'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/editor-labelling/:projectLabellingId',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/labelling`,
          },
          { text: translate(routeParams.language,'New Labelling'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'New Labelling'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/:projectID/editor-labelling',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.rows.id}/labelling`,
          },
          { text: translate(routeParams.language,'New Labelling'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'New Labelling'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/projects/editor-scene/:projectID',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Project',
          alias: 'rows',
          where: { id: routeParams.projectID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/${result.rows.id}/overview`,
          },
          { text: translate(routeParams.language,'Scene'), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'New scene'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/projects/editor-scene/:sceneID',
      '/:language/companies/:companyId/projects/editor-scene/:sceneID/edit/create',
      '/:language/companies/:companyId/projects/editor-scene/:sceneID/edit/layers',
      '/:language/companies/:companyId/projects/editor-scene/:sceneID/edit/settings',
      '/:language/companies/:companyId/projects/editor-scene/:sceneID/edit/playground',
    ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'projectScene',
          alias: 'row',
          where: { id: routeParams.sceneID },
          output: {
            id: true,
            name: true,
            projectId: true,
            project: {
              name: true,
              id: true,
            },
          },
        })

        return [
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.row.project.name, 20, "..."),
            link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.row.project.id}/scenes`,
          },
          { text: truncateMiddle(result.row.name, 20, "..."), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Scene'), active: true },
        ]
      }
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/preview',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/analytics',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/analytics/overview',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/analytics/data',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/analytics/heatmap'
    ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'ProjectLabelling',
          alias: 'row',
          where: { id: routeParams.labellingID },
          output: {
            id: true,
            name: true,
            projectId: true,
            project: {
              name: true,
              id: true,
            },
          },
        })

        return [
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.row.project.name, 20, "..."),
            link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.row.project.id}/overview`,
          },
          { text: truncateMiddle(result.row.name, 20, "..."), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          { text: translate(routeParams.language,'Preview'), active: true },
        ]
      }
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/create',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/create/:imageID',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/autoLabelling',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/autoLabelling/information',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/autoLabelling/logs',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/autoChecking',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/autoChecking/information',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/autoChecking/logs',
      '/:language/companies/:companyId/editor-labelling/:labellingID/edit/settings',
    ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'ProjectLabelling',
          alias: 'row',
          where: { id: routeParams.labellingID },
          output: {
            id: true,
            name: true,
            projectId: true,
            project: {
              name: true,
              id: true,
            },
          },
        })

        return [
          { text: translate(routeParams.language,'Projects'), link: `/${routeParams.language}/companies/${routeParams.companyId}/projects` },
          {
            text: truncateMiddle(result.row.project.name, 20, "..."),
            link: `/${routeParams.language}/companies/${routeParams.companyId}/projects/${result.row.project.id}/labelling`,
          },
          { text: truncateMiddle(result.row.name, 20, "..."), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
          { text: translate(routeParams.language,'Labelling'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
        { active: true, text: translate(routeParams.language,'Knowledge Vision') },
      ]
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: '/' },
        { active: true, text: translate(routeParams.language,'companies') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/testing/add-testing',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/testing` },
        { active: true, text: translate(routeParams.language,'New testing') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/add-train',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'New model') },
      ]
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/compare-metrics',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Comparison metrics') },
      ]
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/compare-matrix',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Comparison confusion matrix') },
      ]
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/add-company',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: '/' },
        { active: true, text: translate(routeParams.language,'New company') },
      ]
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/edit',
      '/:language/companies/:companyId/edit/description',
      '/:language/companies/:companyId/edit/user',
      '/:language/companies/:companyId/edit/setting',
      '/:language/companies/:companyId/edit/setting',
      '/:language/companies/:companyId/edit/setting/api',
      '/:language/companies/:companyId/edit/setting/status',
      '/:language/companies/:companyId/edit/setting/categories',
      '/:language/companies/:companyId/edit/setting/priorities',
      '/:language/companies/:companyId/edit/setting/checklists',
      '/:language/companies/:companyId/edit/setting/comments',
      '/:language/companies/:companyId/edit/setting/inboundmail',
      '/:language/companies/:companyId/edit/setting/security'
    ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Company',
          alias: 'row',
          where: { id: routeParams.companyId },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: truncateMiddle(result.row.name, 20, "..."), active: true },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Edit company') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/add-inference',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferencia'), link: '/admin/inferences' },
        { active: true, text: translate(routeParams.language,'New inference') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/inference/:id/edit',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferencia'), link: '/admin/inferences' },
        { active: true, text: translate(routeParams.language,'Edit inference') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/inferences',
      '/:language/companies/:companyId/inferences/:inferenceId/add-inference-testing'
    ],
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Inferencia') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/admin',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'admin') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/inferences',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Inferencia') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/add-inference-account',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferences Account'), link: '/admin/inferences-account' },
        { active: true, text: translate(routeParams.language,'New inference account') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/inference-account/:id/edit',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferences Account'), link: '/admin/inferences' },
        { active: true, text: translate(routeParams.language,'Edit inference account') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/inferences-account',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Inferences account') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/admin/accounts',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Accounts') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/information',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'row',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.row.name, 20, '...'), active: true,
          },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Information') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: ['/:language/companies/:companyId/testing/:testingID/information',
            '/:language/companies/:companyId/testing/:testingID/logs',
            '/:language/companies/:companyId/testing/:testingID/reporting',
            '/:language/companies/:companyId/testing/:testingID/visualization',
            '/:language/companies/:companyId/testing/:testingID/settings'
          ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Testing',
          alias: 'row',
          where: { id: routeParams.testingID },
          output: {
            id: true,
            name: true,
          },
        })
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/testing` },
          {
            text: truncateMiddle(result.row.name, 20, '...'), active: true,
          },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/testing` },
          { active: true, text: translate(routeParams.language,'Information') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/trains/compare-matrix',
      '/:language/companies/:companyId/trains/compare-metrics'
    ],
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        {
          text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
        },
        { active: true, text: translate(routeParams.language,'Compare metrics') },
      ]
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/logs',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'row',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Logs') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Logs') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/settings',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'row',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Settings') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Settings') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/checkpoints',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'rows',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Checkpoints') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Checkpoints') },
        ]
      }
    },
  })
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/matrix',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'rows',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Confusion matrix') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Confusion matrix') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/checkpoints/:checkpointID',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'rows',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        const resultCheckPoint: any = await findOne({
          target: 'trainEpoch',
          alias: 'rows',
          where: { id: routeParams.checkpointID },
          output: {
            id: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          {
            text: translate(routeParams.language,'Checkpoints'),
            link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/checkpoints`,
          },
          { active: true, text: resultCheckPoint.rows.id },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Checkpoints') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/testing',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'rows',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Testing') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Testing') },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/accuracy',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'rows',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Accuracy') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Accuracy') },
        ]
      }
    },
  });
  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/trains/:trainID/monitor',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Train',
          alias: 'rows',
          where: { id: routeParams.trainID },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          {
            text: translate(routeParams.language,'Models'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains`,
          },
          {
            text: truncateMiddle(result.rows.name, 20, '...'), link: `/${routeParams.language}/companies/${routeParams.companyId}/trains/${result.rows.id}/information`,
          },
          { active: true, text: translate(routeParams.language,'Monitor') },
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { active: true, text: translate(routeParams.language,'Monitor') },
        ]
      }
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/testing',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Knowledge Vision'), link: `/${routeParams.language}/companies/${routeParams.companyId}/data-stores` },
        { active: true, text: translate(routeParams.language,'Testing') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/inferences',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'Inferencia') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/inferences/form/deploy-inference',
    ],
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferencia'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences` },
        { active: true, text: translate(routeParams.language,'Deploy an API') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/inferences/form/deploy-remote-inference',
    ],
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferencia'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences` },
        { active: true, text: translate(routeParams.language,'Deploy a remote API') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/inferences/:inferenceId/testings/:testingId/reporting',
      '/:language/companies/:companyId/inferences/:inferenceId/testings/:testingId/settings',
      '/:language/companies/:companyId/inferences/:inferenceId/testings/:testingId/logs',
      '/:language/companies/:companyId/inferences/:inferenceId/testings/:testingId/information',
    ],
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferencia'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences` },
        { text: translate(routeParams.language,'Tests'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences/${routeParams.inferenceId}?tab=testingInference` },
        { active: true, text: translate(routeParams.language,'Testing') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/inferences/form/deploy-flow-api',
    ],
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { text: translate(routeParams.language,'Inferencia'), link: `/${routeParams.language}/companies/${routeParams.companyId}/inferences` },
        { active: true, text: translate(routeParams.language,'Deploy a flow API') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/web-view/editor',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
        { active: true, text: translate(routeParams.language,'web-view') },
      ];
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/companies/:companyId/dash',
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'Company',
          alias: 'row',
          where: { id: routeParams.companyId },
          output: {
            id: true,
            name: true,
          },
        })

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: result.row.name, active: true }
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/dash` },
          { text: translate(routeParams.language,'Document processed'), active: true },
        ]
      }
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: '/:language/dash',
    resolver: async ({ routeParams }: any) => {
      return [
        { text: translate(routeParams.language,'Home'), link: `/` },
        { text: translate(routeParams.language,'Inbox'), active: true },
      ]
    },
  });

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/dash/analytics/:requestID/document',
      '/:language/companies/:companyId/dash/analytics/:requestID/information',
      '/:language/companies/:companyId/dash/analytics/:requestID/developers',
      '/:language/companies/:companyId/dash/analytics/:requestID/comments',
      '/:language/companies/:companyId/dash/analytics/:requestID/validation',
      '/:language/companies/:companyId/dash/analytics/:requestID/data',
      '/:language/companies/:companyId/dash/analytics/:requestID',
      '/:language/companies/:companyId/dash/analytics/:requestID/overview',
    ],
    resolver: async ({ routeParams }: any) => {
      try {
        const result: any = await findOne({
          target: 'request',
          alias: 'row',
          where: { id: routeParams.requestID },
          output: {
            id: true,
            number: true,
            company: {
              id: true,
              name: true,
            }
          },
        })

        console.info(result)

        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}` },
          { text: result.row.company.name, link: `/${routeParams.language}/companies/${routeParams.companyId}/dash` },
          { text: `${translate(routeParams.language,"Document processed")} #${result.row.number}`, active: true }
        ]
      } catch (error) {
        return [
          { text: translate(routeParams.language,'Home'), link: `/${routeParams.language}/companies/${routeParams.companyId}/dash` },
          { text: translate(routeParams.language,'Document processed'), active: true },
        ]
      }
    },
  })

  emitter.on({
    event: 'breadcrumb',
    route: [
      '/:language/companies/:companyId/analyticspage',
    ],
    resolver: async ({ routeParams }: any) => {
        return [
          { text: translate(routeParams.language, 'Home'), link: `/${routeParams.language}` },
          { text: translate(routeParams.language, 'Analytics'), active: true },
        ]
    },
  })
}



// WEBPACK FOOTER //
// ./src/listeners/breadcrumb/index.ts